<script>
  import Stage from "./Stage.svelte"
  import Grid from "./Grid.svelte"
  import { shuffle } from "shufflr"

  export let glyphGroups
  export let dimensions
  let glyph = randomGlyph()

  function randomGlyph() {
    const glyphs = Object.values(glyphGroups).flat()
    return shuffle(glyphs)[0]
  }

  function onClick(event) {
    glyph = event.detail.glyph
  }
</script>

<div class="root">
  <div class="stage">
    <Stage {glyph} {dimensions} />
  </div>

  <div class="glyphs">
    <Grid {glyphGroups} selected={glyph} on:click={onClick} />
  </div>
</div>

<style lang="scss">
  @use "../../partials";

  .root {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: min-content;
    grid-column-gap: calc(var(--grid-column-gap) * 2);
    align-items: start;

    @include partials.media(">phone") {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .stage {
    --top: var(--line-height-m);

    position: sticky;
    top: var(--top);

    grid-column-start: 1;
    grid-column-end: 2;

    @include partials.media("<=phone") {
      display: none;
    }
  }

  .glyphs {
    @include partials.media(">phone") {
      grid-column-start: 2;
      grid-column-end: -1;
    }
  }
</style>
